import React from 'react';

const steps = [
  {
    num: '01',
    title: 'Discovery Call',
    description: 'We learn your business, your buyers, and your goals. No fluff. Just questions that matter.',
  },
  {
    num: '02',
    title: 'Build the System',
    description: 'We create scripts, email templates, target lists, and the whole outbound machine.',
  },
  {
    num: '03',
    title: 'Launch & Execute',
    description: 'Meetings start showing up on your calendar. Deals start moving through your pipeline.',
  },
  {
    num: '04',
    title: 'Optimize & Scale',
    description: 'We track what works, kill what doesn\'t, and double down on what makes you money.',
  },
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="section" style={{ backgroundColor: 'var(--bg-secondary)' }}>
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="heading-lg mb-4">How It Works</h2>
          <p className="text-base md:text-lg" style={{ color: 'var(--text-secondary)' }}>
            Four steps. No mystery. No magic.
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-10">
          {steps.map((step) => (
            <div key={step.num} className="flex items-start gap-6" data-testid={`step-${step.num}`}>
              <div
                className="flex-shrink-0 w-14 h-14 rounded-2xl flex items-center justify-center text-lg font-bold"
                style={{ backgroundColor: 'var(--brand-primary)', color: '#fff' }}
              >
                {step.num}
              </div>
              <div>
                <h3 className="text-xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
                  {step.title}
                </h3>
                <p style={{ color: 'var(--text-secondary)' }}>{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
